import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import Login from '@/components/Login'
import Warehousing from '@/components/Warehousing'
import TakePart from '@/components/TakePart'
import TakeCash from '@/components/TakeCash'
import ScoreToMoney from '@/components/operations/ScoreToMoney'
import Address from '@/components/userinfos/AddressManager'
import My from '@/components/My'
import UserInfo from '@/components/UserInfo'
import WorksiteEdit from '@/components/userinfos/WorksiteEdit'
import RealnameEdit from '@/components/userinfos/RealnameEdit'
import NicknameEdit from '@/components/userinfos/NicknameEdit'
import SexEdit from '@/components/userinfos/SexEdit'
import PhoneEdit from '@/components/userinfos/PhoneEdit'
import IdCardNoEdit from '@/components/userinfos/IdCardNoEdit'
import AuthApply from '@/components/userinfos/AuthApply'
import StudentCardEdit from '@/components/userinfos/StudentCardEdit'
import AddUserInfo from '@/components/AddUserInfo'
import Robbing from '@/components/Robbing'
import RobbingList from '@/components/RobbingList'
import RobbingListCompleteOrCancel from '@/components/RobbingListCompleteOrCancel'
import ExpressTotakeList from '@/components/ExpressTotakeList'
import ExpressQrcode from '@/components/ExpressQrcode'
import ExpressTopay from '@/components/ExpressTopay'
import ExpressTotakein from '@/components/ExpressTotakein'
import Yunfei from '@/components/infos/Yunfei'
import ExpressSendList from '@/components/ExpressSendList'
import Qrcode from '@/components/Qrcode'
import Error from '@/components/Error'
import ProxyGet from '@/components/operations/ProxyGet'
import DoorService from '@/components/operations/DoorService'
import OrderSuccess from '@/components/operations/OrderSuccess'
import PaySuccess from '@/components/operations/PaySuccess'
import Introduction from '@/components/infos/Introduction'
import PaotuiMakeMoney from '@/components/infos/PaotuiMakeMoney'
import SetBuildingManager from '@/components/operations/SetBuildingManager'
import PaotuiStatusInfo from '@/components/operations/PaotuiStatusInfo'
import PaotuiLeaderSign from '@/components/operations/PaotuiLeaderSign'
import PaotuiQrcode from '@/components/operations/PaotuiQrcode'
import PaotuiOrderForDownload from '@/components/operations/PaotuiOrderForDownload'
import MoneyDetail from '@/components/infos/MoneyDetail'
import CreditscoreDetail from '@/components/infos/CreditscoreDetail'
import TakecashList from '@/components/infos/TakecashList'
import PrintSurface from '@/components/operations/PrintSurface'
import Suggestion from '@/components/operations/Suggestion'
import SuggestionSuccess from '@/components/operations/SuggestionSuccess'
import SuggestionDetail from '@/components/operations/SuggestionDetail'
import StatisticsDetail from '@/components/infos/StatisticsDetail'
import DailyStatic from '@/components/infos/DailyStatic'
import Answer from '@/components/operations/Answer'
import Return from '@/components/operations/Return'
import Comment from '@/components/operations/Comment'
import PaotuiAgreement from '@/components/infos/PaotuiAgreement'
import PaotuiApply from '@/components/operations/PaotuiApply'
import ToTakeinOutScan from '@/components/operations/ToTakeinOutScan'
import CancelPaotuiAccept from '@/components/operations/CancelPaotuiAccept'
import QujianTips from '@/components/infos/QujianTips'
import JijianTips from '@/components/infos/JijianTips'
import PaotuiTips from '@/components/infos/PaotuiTips'
import PaotuiFeeTips from '@/components/infos/PaotuiFeeTips'
import Help from '@/components/infos/Help'
import ServiceHelp from '@/components/infos/ServiceHelp'
import SubscribeActive from '@/components/actives/subscribe'
import Donate from '@/components/actives/donate'
import Deposit from '@/components/common/DepositMoney'
import Home from '@/components/home/Home'
import WorksiteList from '@/components/operations/WorksiteList'
import Active from '@/components/actives/detail'
import Tongji from '@/components/common/Tongji'
import CircleType from '@/components/operations/CircleType'
import CircleEdit from '@/components/operations/CircleEdit'
import CircleDetail from '@/components/infos/CircleDetail'
import MyCircle from '@/components/infos/MyCircle'
import Share from '@/components/common/Share'
import CircleDiscovery from '@/components/infos/CircleDiscovery'
import CircleMaiList from '@/components/infos/CircleMaiList'
import CircleSfEdit from '@/components/operations/CircleSfEdit'
import CircleBBList from '@/components/infos/CircleBBList'
import CircleBBEdit from '@/components/operations/CircleBBEdit'
import CircleJiyuList from '@/components/infos/CircleJiyuList'
import CircleJyEdit from '@/components/operations/CircleJyEdit'
import CircleShareList from '@/components/infos/CircleShareList'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'HelloWorld',
      component: HelloWorld
    },
    {
      path: '/home/:token',
      name: 'Home',
      component: Home
    },
    {
      path: '/share/:target/:id',
      name: 'Share',
      component: Share
    },
    {
      path: '/circleDiscovery/:token',
      name: 'CircleDiscovery',
      component: CircleDiscovery
    },
    {
      path: '/myCircle/:token',
      name: 'MyCircle',
      component: MyCircle
    },
    {
      path: '/circleType/:bizType/:token',
      name: 'CircleType',
      component: CircleType
    },
    {
      path: '/circleEdit/:bizType/:goodsType/:id/:token',
      name: 'CircleEdit',
      component: CircleEdit
    },
    {
      path: '/circleDetail/:id/:token',
      name: 'CircleDetail',
      component: CircleDetail
    },
    {
      path: '/circleMaiList/:token',
      name: 'CircleMaiList',
      component: CircleMaiList
    },
    {
      path: '/circleSfEdit/:token',
      name: 'CircleSfEdit',
      component: CircleSfEdit
    },
    {
      path: '/circleBBEdit/:token',
      name: 'CircleBBEdit',
      component: CircleBBEdit
    },
    {
      path: '/circleJyEdit/:token',
      name: 'CircleJyEdit',
      component: CircleJyEdit
    },
    {
      path: '/circleBBList/:token',
      name: 'CircleBBList',
      component: CircleBBList
    },
    {
      path: '/circleJiyuList/:token',
      name: 'CircleJiyuList',
      component: CircleJiyuList
    },
    {
      path: '/circleShareList/:token',
      name: 'CircleShareList',
      component: CircleShareList
    },
    {
      path: '/tongji/:token',
      name: 'Tongji',
      component: Tongji
    },
    {
      path: '/qrcode',
      name: 'Qrcode',
      component: Qrcode
    },
    {
      path: '/qujianTips',
      name: 'QujianTips',
      component: QujianTips
    },
    {
      path: '/jijianTips',
      name: 'JijianTips',
      component: JijianTips
    },
    {
      path: '/paotuiTips',
      name: 'PaotuiTips',
      component: PaotuiTips
    },
    {
      path: '/paotuiFeeTips',
      name: 'PaotuiFeeTips',
      component: PaotuiFeeTips
    },
    {
      path: '/serviceHelp/:token',
      name: 'ServiceHelp',
      component: ServiceHelp
    },
    {
      path: '/help',
      name: 'Help',
      component: Help
    },
    {
      path: '/error/:errorCode',
      name: 'Error',
      component: Error
    },
    {
      path: '/bind/:redirect/:token',
      name: 'Login',
      component: Login
    },
    {
      path: '/warehousing/:token',
      name: 'Warehousing',
      component: Warehousing
    },
    {
      path: '/takepart/:token',
      name: 'TakePart',
      component: TakePart
    },
    {
      path: '/takecash/:token',
      name: 'TakeCash',
      component: TakeCash
    },
    {
      path: '/address/:token',
      name: 'Address',
      component: Address
    },
    {
      path: '/my/:token',
      name: 'My',
      component: My
    },
    {
      path: '/userInfo/:platform/:token',
      name: 'UserInfo',
      component: UserInfo
    },
    {
      path: '/worksiteEdit/:token',
      name: 'WorksiteEdit',
      component: WorksiteEdit
    },
    {
      path: '/realnameEdit',
      name: 'RealnameEdit',
      component: RealnameEdit
    },
    {
      path: '/nicknameEdit',
      name: 'NicknameEdit',
      component: NicknameEdit
    },
    {
      path: '/sexEdit',
      name: 'SexEdit',
      component: SexEdit
    },
    {
      path: '/phoneEdit',
      name: 'PhoneEdit',
      component: PhoneEdit
    },
    {
      path: '/idCardNoEdit/:token',
      name: 'IdCardNoEdit',
      component: IdCardNoEdit
    },
    {
      path: '/authApply/:type/:redirect/:token', // 0普通认证  1跑腿认证
      name: 'AuthApply',
      component: AuthApply
    },
    {
      path: '/studentCardEdit/:token',
      name: 'StudentCardEdit',
      component: StudentCardEdit
    },
    {
      path: '/addUserInfo/:redirect/:token',
      name: 'AddUserInfo',
      component: AddUserInfo
    },
    {
      path: '/robbing/:token',
      name: 'Robbing',
      component: Robbing
    },
    {
      path: '/robbingList/:type/:status/:token',
      name: 'RobbingList',
      component: RobbingList
    },
    {
      path: '/robbingListCompleteOrCancel/:type/:status/:token',
      name: 'RobbingListCompleteOrCancel',
      component: RobbingListCompleteOrCancel
    },
    {
      path: '/expressTotakeList/:status/:token',
      name: 'ExpressTotakeList',
      component: ExpressTotakeList
    },
    {
      path: '/expressQrcode/:expressId/:token',
      name: 'ExpressQrcode',
      component: ExpressQrcode
    },
    {
      path: '/safekeepFeeToPay/:expressId/:token',
      name: 'ExpressTopay',
      component: ExpressTopay
    },
    {
      path: '/proxyGet/:toTakeId/:token',
      name: 'ProxyGet',
      component: ProxyGet
    },
    {
      path: '/doorService/:toTakeId/:token',
      name: 'DoorService',
      component: DoorService
    },
    {
      path: '/setBuildingManager/:token',
      name: 'SetBuildingManager',
      component: SetBuildingManager
    },
    {
      path: '/paotuiStatusInfo/:token',
      name: 'PaotuiStatusInfo',
      component: PaotuiStatusInfo
    },
    {
      path: '/paotuiLeaderSign/:paotuiId/:token',
      name: 'PaotuiLeaderSign',
      component: PaotuiLeaderSign
    },
    {
      path: '/paotuiQrcode/:token',
      name: 'PaotuiQrcode',
      component: PaotuiQrcode
    },
    {
      path: '/paotuiOrderForDownload/:token',
      name: 'paotuiOrderForDownload',
      component: PaotuiOrderForDownload
    },
    {
      path: '/orderSuccess/:paotuiId/:token',
      name: 'OrderSuccess',
      component: OrderSuccess
    },
    {
      path: '/paySuccess/:token',
      name: 'PaySuccess',
      component: PaySuccess
    },
    {
      path: '/expressTotakein/:token',
      name: 'ExpressTotakein',
      component: ExpressTotakein
    },
    {
      path: '/yunfei',
      name: 'Yunfei',
      component: Yunfei
    },
    {
      path: '/expressSendList/:status/:token',
      name: 'ExpressSendList',
      component: ExpressSendList
    },
    {
      path: '/introduction',
      name: 'Introduction',
      component: Introduction
    },
    {
      path: '/paotuiAgreement',
      name: 'PaotuiAgreement',
      component: PaotuiAgreement
    },
    {
      path: '/paotuiApply/:token',
      name: 'PaotuiApply',
      component: PaotuiApply
    },
    {
      path: '/paotuiMakeMoney',
      name: 'PaotuiMakeMoney',
      component: PaotuiMakeMoney
    },
    {
      path: '/creditscoreDetail/:token',
      name: 'CreditscoreDetail',
      component: CreditscoreDetail
    },
    {
      path: '/moneyDetail/:type/:token',
      name: 'MoneyDetail',
      component: MoneyDetail
    },
    {
      path: '/takecashList/:token',
      name: 'TakecashList',
      component: TakecashList
    },
    {
      path: '/scoreToMoney/:token',
      name: 'ScoreToMoney',
      component: ScoreToMoney
    },
    {
      path: '/printSurface/:token',
      name: 'PrintSurface',
      component: PrintSurface
    },
    {
      path: '/suggestion/:token',
      name: 'Suggestion',
      component: Suggestion
    },
    {
      path: '/suggestionSuccess/:id/:token',
      name: 'SuggestionSuccess',
      component: SuggestionSuccess
    },
    {
      path: '/suggestionDetail/:id/:token',
      name: 'SuggestionDetail',
      component: SuggestionDetail
    },
    {
      path: '/answer/:toOpenid/:token',
      name: 'Answer',
      component: Answer
    },
    {
      path: '/statisticsDetail/:id/:token',
      name: 'StatisticsDetail',
      component: StatisticsDetail
    },
    {
      path: '/dailyStatic/:date',
      name: 'DailyStatic',
      component: DailyStatic
    },
    {
      path: '/return/:token',
      name: 'Return',
      component: Return
    },
    {
      path: '/comment/:id/:acceptOpenid/:paotuiName/:paotuiTime/:token',
      name: 'Comment',
      component: Comment
    },
    {
      path: '/toTakeinOutScan/:token',
      name: 'ToTakeinOutScan',
      component: ToTakeinOutScan
    },
    {
      path: '/cancelPaotuiAccept/:orderNo/:paotuiType/:token',
      name: 'CancelPaotuiAccept',
      component: CancelPaotuiAccept
    },
    {
      path: '/subscribeActive/:token',
      name: 'SubscribeActive',
      component: SubscribeActive
    },
    {
      path: '/donate/:token',
      name: 'Donate',
      component: Donate
    },
    {
      path: '/deposit/:token',
      name: 'Deposit',
      component: Deposit
    },
    {
      path: '/worksiteList',
      name: 'WorksiteList',
      component: WorksiteList
    },
    {
      path: '/active/:id/:token',
      name: 'Active',
      component: Active
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js